// Keep this in sync with liquitics/reference/data/choices.py
export const PRODUCT_TYPE_DISPLAY_NAMES: { [key: string]: string; } = {
    'BOND': 'Bond',
    'CLIENTACCOUNTTXN': 'Client Account Transaction',
    'DEPOSIT': 'Deposit',
    'EXPORTBILL': 'Export Bill',
    'EXPORTLC': 'Export Letter of Credit',
    'FX': 'FX',
    'IMPORTBILL': 'Import Bill',
    'IMPORTLC': 'Import Letter of Credit',
    'LOAN': 'Loan',
    'MARGINCALL': 'Margin Call',
    'MM': 'MM',
    'PAYMENT': 'Payment',
    'REPO': 'Repo',
};

export function productTypeDisplayName(productType: string) {
    let displayProductType = PRODUCT_TYPE_DISPLAY_NAMES[productType];
    if (!displayProductType) {
        displayProductType = productType;
    }
    return displayProductType;
}
